<template>
  <div class="col-sm-12">
    <div class="card">
      

      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <div class="table-responsive" v-if="!loading && historyList.length > 0">
        <table class="table">
          <thead>
          <tr class="border-bottom-primary">
            <th scope="col">Date</th>
            <th scope="col">Remarks</th>
            <th scope="col">Created By</th>
            <th scope="col">Items</th>
            <th scope="col">Documents</th>
            <th scope="col">Approval Status</th>
            <th scope="col">Action</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="entry in historyList" :key="entry.id">
            <td>{{ formatDate(entry.created_at) }}</td>
            <td>{{ entry.remarks || "-" }}</td>
            <td>{{ entry.created_by_name || "N/A" }}</td>
            <td>
              <span class="count-badge">{{ entry.items_count }}</span>
            </td>
            <td>
              <span class="count-badge">{{ entry.documents_count }}</span>
            </td>
            <td>
              <span class="status-tag" :class="approvalStatusClass(entry.approval_status)">
                {{ approvalStatusLabel(entry.approval_status) }}
              </span>
            </td>
            <td>
              <button class="btn-view" @click="viewTrust(entry.id)">
                <i class="fa fa-eye"></i> View
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-else-if="!loading && historyList.length === 0" class="no-data-message">
        No trust history found for this dealer.
      </div>
    </div>
  </div>
</template>

<script>
import { fetchTrustListByDealer } from "@/services/dataService";

export default {
  name: "TrustHistoryList",
  data() {
    return {
      dealerId: this.$route.params.id,
      token: localStorage.getItem("token_set") || "",
      loading: false,
      historyList: [],
    };
  },
  methods: {
    async getTrustHistory() {
      try {
        this.loading = true;
        const response = await fetchTrustListByDealer(this.dealerId, this.token);
        this.historyList = response.data?.data || [];
      } catch (error) {
        console.error("Error fetching trust history:", error);
        this.historyList = [];
      } finally {
        this.loading = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    viewTrust(trustId) {
      this.$router.push({ path: `/view-trust-details/${trustId}` });
    },

    goBack() {
      this.$router.back();
    },

    approvalStatusLabel(status) {
      const map = { 0: "Pending", 1: "Approved", 2: "Rejected" };
      return map[Number(status)] ?? "Unknown";
    },

    approvalStatusClass(status) {
      const map = { 0: "status-pending", 1: "status-approved", 2: "status-rejected" };
      return map[Number(status)] || "status-unknown";
    },
  },
  mounted() {
    this.getTrustHistory();
  },
};
</script>

<style scoped>
.card {
  padding: 10px;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 10px;
  margin-bottom: 10px;
}

.page-title {
  margin: 0;
  color: #333;
}

.btn-back {
  padding: 8px 16px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: #f8f9fa;
  color: #374151;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s ease;
}

.btn-back:hover {
  background-color: #e5e7eb;
}

.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
}

.count-badge {
  display: inline-block;
  min-width: 28px;
  padding: 4px 10px;
  border-radius: 12px;
  background-color: #eaf2ff;
  color: #1c66ad;
  font-weight: 600;
  font-size: 13px;
  text-align: center;
}

.btn-view {
  padding: 6px 12px;
  border-radius: 5px;
  border: 1px solid #1c66ad;
  background-color: #eaf2ff;
  color: #1c66ad;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: background-color 0.2s ease;
}

.btn-view:hover {
  background-color: #d6e7ff;
}

.no-data-message {
  text-align: center;
  padding: 20px;
  color: #6c757d;
  font-style: italic;
}

.status-tag {
  display: inline-block;
  min-width: 80px;
  padding: 4px 12px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 13px;
  text-align: center;
}

.status-pending {
  background-color: #fff4d6;
  color: #9a6700;
}

.status-approved {
  background-color: #dcf5e3;
  color: #1a7f37;
}

.status-rejected {
  background-color: #fde2e2;
  color: #c0392b;
}

.status-unknown {
  background-color: #e5e7eb;
  color: #4b5563;
}
</style>